export const HolidayOrder = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.256" height="13.076" viewBox="0 0 15.256 13.076">
            <path id="Icon_material-history" data-name="Icon material-history"
                  d="M10.217,4.5a6.539,6.539,0,0,0-6.538,6.538H1.5l2.826,2.826.051.1,2.935-2.928H5.132a5.11,5.11,0,1,1,1.5,3.589L5.6,15.658A6.536,6.536,0,1,0,10.217,4.5ZM9.491,8.132v3.632L12.6,13.61l.523-.879L10.581,11.22V8.132Z"
                  transform="translate(-1.5 -4.5)"/>
        </svg>
    )
}
